import styles from './FilterPlacesMobile.module.css'
import arrowLeft from '../../assets/icons/arrowLeft.svg'
import { useState } from 'react'
import CustomButton from '../UI/CustomButton/CustomButton'

interface Props {
  onClickHandler: () => void
  closeFilter: () => void
  placeNames?: string[]
  placeNamesReports?: { value: number | string; label: string }[]
  setPlaceFilter: React.Dispatch<React.SetStateAction<string>>
}

const FilterPlacesMobile: React.FC<Props> = ({
  onClickHandler,
  placeNames,
  setPlaceFilter,
  closeFilter,
  placeNamesReports,
}) => {
  const [selected, setSelected] = useState<string>('')

  return (
    <div className={styles.filterContainer}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <img onClick={onClickHandler} src={arrowLeft} alt='Back' />
          <div>Компании</div>
        </div>
        <div className={styles.content}>
          {placeNames &&
            placeNames?.map((item) => (
              <div
                onClick={() => setSelected(item)}
                className={
                  selected === item ? `${styles.active} ${styles.contentItem}` : styles.contentItem
                }
                key={item}
              >
                {item}
              </div>
            ))}
          {placeNamesReports &&
            placeNamesReports?.map((item: any) => (
              <div
                onClick={() => setSelected(item.value)}
                className={
                  selected === item.value
                    ? `${styles.active} ${styles.contentItem}`
                    : styles.contentItem
                }
                key={item.id}
              >
                {item.label}
              </div>
            ))}
        </div>
      </div>
      <div className={styles.footerContainer}>
        <CustomButton
          title='Применить'
          className={styles.filtersBtn}
          type='button'
          onClick={() => {
            setPlaceFilter(selected)
            onClickHandler()
            closeFilter()
          }}
        />
      </div>
    </div>
  )
}

export default FilterPlacesMobile
